module.exports = __webpack_public_path__ + "img/tank-turret-mask.45e22b6f.png";